import { Doc } from "../../_generated/dataModel";
import { FilterRule, FilterRuleCtx } from "../../lib/types/filters_types";

/**
 * Regla: filtro por estado interno del proveedor (prioridad 6)
 * Filtra proveedores por estado: active, inactive, blocked
 */
export const supplierStateRule: FilterRule<Doc<"suppliers">> = {
  priority: 6,
  build: async (ctx: FilterRuleCtx, args: Partial<Omit<Doc<"suppliers">, "_id" | "_creationTime">>) => {
    const { userContext } = ctx;
    const state = args.internalControl?.state;

    // Validación: si no hay state, retornar undefined
    if (!state) return undefined;

    // Validación: verificar que el usuario tenga companyId
    if (!userContext?.companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    const suppliers = await ctx.db
      .query("suppliers")
      .withIndex("by_company_id", (q) =>
        q.eq("internalControl.companyId", userContext.companyId!),
      )
      .collect();

    return suppliers.filter(
      (supplier) => supplier?.internalControl?.state === state,
    );
  },
};
